// eslint-disable-next-line no-undef
class ContactForm extends HTMLElement {
  constructor () {
    super()

    this.fetchRetries = 0
    this.fetchRetriesMax = 5

    this.form = this.querySelector('.sec-Form')
    this.formHeader = this.querySelector('.frm-Form_Header')
    this.subjectField = this.querySelector('#contactFormSubject')
    this.formEl = this.querySelector('#contact_form')
    this.submitButton = this.querySelector('button[type="submit"]')
    this.responseMessage = this.querySelector('#contactFormResponseMessage')

    this.issueTool = this.querySelector('#contactFormTechnicalIssue')
    this.websiteRegion = this.querySelector('#contactFormWebsiteRegions')
    this.technicalDevice = this.querySelector(
      '#contactFormTechnicalIssueDevice',
    )
    this.technicalAttachments = this.querySelector(
      '#contactFormTechnicalIssueAttachements',
    )
    this.deliveryTackingCategory = this.querySelector(
      '#contactFormDeliveryTrackingCategory',
    )
    this.orderNumber = this.querySelector('#contactFormOrderNumber')
    this.email = this.querySelector('#contactFormEmail')
    this.firstName = this.querySelector('#contactFormFirstName')
    this.lastName = this.querySelector('#contactFormLastName')
    this.postcode = this.querySelector('#contactFormPostCode')
    this.productIssue = this.querySelector('#contactFormProductIssue')
    this.productDescription = this.querySelector(
      '#contactFormProductDescription',
    )
    this.solutionOption = this.querySelector('#contactFormSolutionOption')
    this.returnTracking = this.querySelector(
      '#contactFormReturnsTrackingNumber',
    )
    this.productsReturned = this.querySelector('#contactFormProductsReturned')
    this.issueAttachments = this.querySelector(
      '#contactFormProductIssueProductAttachements',
    )
    this.message = this.querySelector('#contactFormMessage')
    this.cancelMessage = this.querySelector('#contactFormCancelChangeMessage')
    this.technicalMessage = this.querySelector(
      '#contactFormTechnicalIssueMessage',
    )
    this.productIssueMessage = this.querySelector(
      '#contactFormProductIssueMessage',
    )

    this.sourceStore = this.querySelector('#contactFormSourceStore')

    this.formEl.addEventListener('submit', e => {
      e.preventDefault()
      e.stopImmediatePropagation()
      e.stopPropagation()
      this.submitRequest()
    })

    this.onSubjectChange()
    this.initialiseAccordion()
    this.restrictSelectFields()

    if (window.location.href.includes('?contact_posted=true#contact_form')) {
      this.form.setAttribute('aria-expanded', true)
    }
  }

  onSubjectChange () {
    this.subjectField.addEventListener('change', e => {
      const subjectFieldValue = e.target.value
      const subjectHandlized = subjectFieldValue
        .toLowerCase()
        .trim()
        .replaceAll(' ', '-')
        .replaceAll('/', '-')

      this.form.dataset.subject = subjectHandlized
      this.restrictTextfields(subjectHandlized)
      this.restrictSelectFields()
    })
  }

  restrictTextfields (subject) {
    this.revertTextFields()

    const textFieldWrappers = this.formEl.querySelectorAll(
      `[data-subject*=${subject}]`,
    )

    textFieldWrappers.forEach(field => {
      const textField = field.querySelector('textarea')
      textField.setAttribute('required', 'required')
    })
  }

  revertTextFields () {
    const textFields = this.formEl.querySelectorAll('textarea')
    textFields.forEach(field => {
      field.removeAttribute('required')
    })
  }

  restrictSelectFields () {
    const selectFields = this.formEl.querySelectorAll('select:not(#contactFormSubject)')

    selectFields.forEach(select => {
      select.removeAttribute('required')
    })

    selectFields.forEach(select => {
      const wrapper = select.closest('.frm-Form_Row')
      if (wrapper) {
        const computedStyle = window.getComputedStyle(wrapper)
        if (computedStyle.display !== 'none') {
          select.setAttribute('required', 'required')
        }
      }
    })
  }

  initialiseAccordion () {
    this.handleClick = this.handleClick.bind(this)
    this.formHeader.addEventListener('click', this.handleClick)
  }

  handleClick () {
    const currentState = this.form.getAttribute('aria-expanded') === 'true'
    this.form.setAttribute('aria-expanded', !currentState)
  }

  async submitRequest (e) {
    this.submitButton.setAttribute('disabled', 'true')
    this.submitButton.innerText = 'Submitting ...'

    let uploadTokens = []
    let submitData = {}

    if (this.form.dataset.subject === 'technical-issue') {
      const files = [...this.technicalAttachments.files]

      if (files.length > 0) {
        uploadTokens = await this.handleFileUploadChange(files)
      }
    } else if (this.form.dataset.subject === 'issue-with-product') {
      const files = [...this.issueAttachments.files]

      if (files.length > 0) {
        uploadTokens = await this.handleFileUploadChange(files)
      }
    }

    if (uploadTokens === 'error-stop') {
      this.submitButton.innerText = 'Submit'
      this.submitButton.removeAttribute('disabled')
      return
    }

    submitData = {
      ticket: {
        requester: {
          name: `${this.firstName.value} ${this.lastName.value}`,
          email: this.email.value,
        },
        subject: `Contact form - ${this.subjectField.value}`,
        comment: {},
        tags: [],
        custom_fields: [
          {
            id: 22736847981201,
            value: `${this.firstName.value} ${this.lastName.value}`,
          },
          {
            id: 22736871433489,
            value: this.email.value,
          },
          {
            id: 360000676971,
            value: this.orderNumber.value,
          },
        ],
      },
    }

    switch (this.form.dataset.subject) {
      case 'delivery-tracking':
        submitData.ticket.tags = [this.zendeskSubCategoryTag]
        submitData.ticket.comment = {
          html_body: `<p><strong>First Name:</strong><br>${this.firstName.value}<br><br><strong>Last Name:</strong><br>${this.lastName.value}<br><br><strong>Order Number:</strong><br>${this.orderNumber.value}<br><br><strong>Postcode or Zip Code:</strong><br>${this.postcode.value}<br><br><strong>Delivery/Tracking Issue:</strong><br>${this.deliveryTackingCategory.value}<br><br><strong>Message:</strong><br>${this.message.value}<br><br><strong>Source Store:</strong><br>${this.sourceStore.value}</p>`,
        }
        break

      case 'returns':
        submitData.ticket.tags = [this.zendeskTag]
        submitData.ticket.comment = {
          html_body: `<p><strong>First Name:</strong><br>${this.firstName.value}<br><br><strong>Last Name:</strong><br>${this.lastName.value}<br><br><strong>Order Number:</strong><br>${this.orderNumber.value}<br><br><strong>Postcode or Zip Code:</strong><br>${this.postcode.value}<br><br><strong>Return Tracking Number:</strong><br>${this.returnTracking.value}<br><br><strong>Items Returned:</strong><br>${this.productsReturned.value}<br><br><strong>Message:</strong><br>${this.message.value}<br><br><strong>Source Store:</strong><br>${this.sourceStore.value}</p>`,
        }
        break

      case 'issue-with-product':
        submitData.ticket.tags = [this.zendeskSubCategoryTag]
        submitData.ticket.comment = {
          html_body: `<p><strong>First Name:</strong><br>${this.firstName.value}<br><br><strong>Last Name:</strong><br>${this.lastName.value}<br><br><strong>Order Number:</strong><br>${this.orderNumber.value}<br><br><strong>Postcode or Zip Code:</strong><br>${this.postcode.value}<br><br><strong>Product Issue:</strong>${this.productIssue.value}<br><br><strong>Product Information:</strong>${this.productDescription.value}<br><br><strong>Preferred Solution:</strong><br>${this.solutionOption.value}<br><br><strong>Message:</strong>${this.productIssueMessage.value}<br><br><strong>Source Store:</strong><br>${this.sourceStore.value}</p>`,
        }
        if (uploadTokens.length) {
          submitData.ticket.comment = {
            ...submitData.ticket.comment,
            uploads: uploadTokens,
          }
        }
        break

      case 'cancel-change-order':
        submitData.ticket.tags = [this.zendeskTag]
        submitData.ticket.comment = {
          html_body: `<p><strong>First Name:</strong><br>${this.firstName.value}<br><br><strong>Last Name:</strong><br>${this.lastName.value}<br><br><strong>Order Number:</strong><br>${this.orderNumber.value}<br><br><strong>Postcode or Zip Code:</strong><br>${this.postcode.value}<br><br><strong>Message:</strong>${this.cancelMessage.value}<br><br><strong>Source Store:</strong><br>${this.sourceStore.value}</p>`,
        }
        break

      case 'technical-issue':
        submitData.ticket.tags = [this.zendeskSubCategoryTag]
        submitData.ticket.comment = {
          html_body: `<p><strong>First Name:</strong><br>${this.firstName.value}<br><br><strong>Last Name:</strong><br>${this.lastName.value}<br><br><strong>App or Website Issue:</strong><br>${this.issueTool.value}<br><br><strong>Website Region:</strong><br>${this.websiteRegion.value}<br><br><strong>Device/Browser:</strong><br>${this.technicalDevice.value}<br><br><strong>Order Number:</strong><br>${this.orderNumber.value}<br><br><strong>Message:</strong><br>${this.technicalMessage.value}<br><br><strong>Source Store:</strong><br>${this.sourceStore.value}</p>`,
        }
        if (uploadTokens.length) {
          submitData.ticket.comment = {
            ...submitData.ticket.comment,
            uploads: uploadTokens,
          }
        }
        break

      case 'item-is-out-of-stock':
        submitData.ticket.tags = [this.zendeskTag]
        submitData.ticket.comment = {
          html_body: `<p><strong>First Name:</strong><br>${this.firstName.value}<br><br><strong>Last Name:</strong><br>${this.lastName.value}<br><br><strong>Order Number:</strong><br>${this.orderNumber.value}<br><br><strong>Product Information:</strong><br>${this.productDescription.value}<br><br><strong>Message:</strong><br>${this.message.value}<br><br><strong>Source Store:</strong><br>${this.sourceStore.value}</p>`,
        }
        break

      case 'other':
        submitData.ticket.tags = [this.zendeskTag]
        submitData.ticket.comment = {
          html_body: `<p><strong>First Name:</strong><br>${this.firstName.value}<br><br><strong>Last Name:</strong><br>${this.lastName.value}<br><br><strong>Order Number:</strong><br>${this.orderNumber.value}<br><br><strong>Postcode or Zip Code:</strong><br>${this.postcode.value}<br><br><strong>Message:</strong><br>${this.message.value}<br><br><strong>Source Store:</strong><br>${this.sourceStore.value}</p>`,
        }
        break
    }

    const url = 'https://oh-polly-zendesk.vercel.app/api/index.js'
    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(submitData),
    }

    this.fetchRetry(url, options)
      .then(res => res.json())
      .then(data => {
        if (data.ok) {
          this.submitButton.innerText = 'Submitted'
          this.responseMessage.innerText = this.getAttribute(
            'data-success-message',
          )
        } else {
          console.error('Contact form', data.error)
          this.submitButton.removeAttribute('disabled')
          this.submitButton.innerText = 'Submit'
          this.responseMessage.innerText = this.getAttribute(
            'data-error-message',
          )
        }
      })
      .catch(rejected => {
        console.error('Contact form', rejected)

        this.submitButton.innerText = 'Submit'
        this.submitButton.removeAttribute('disabled')
      })
  }

  async handleFileUploadChange (files) {
    const errorMessagesArray = []

    const maxFileSizeInMB = 50
    const oversizedFile = files.find(
      file => file.size / (1024 * 1024) > maxFileSizeInMB,
    )
    const maxFileSizeLocale = 'Please upload files [size] or less.'
    if (oversizedFile) {
      errorMessagesArray.push(
        maxFileSizeLocale.replace('[size]', `${maxFileSizeInMB}MB`),
      )
    }

    const maxFileCount = 5
    const maxFileCountLocale = 'Please upload [count] files or less.'
    if (files.length > maxFileCount) {
      errorMessagesArray.push(
        maxFileCountLocale.replace('[count]', maxFileCount),
      )
    }

    if (errorMessagesArray.length === 1) {
      this.responseMessage.innerText = errorMessagesArray[0]
      return 'error-stop'
    } else if (errorMessagesArray.length >= 1) {
      this.responseMessage.innerText = errorMessagesArray
        .join('. ')
        .replace('..', '.')
      return 'error-stop'
    }

    const tokenResponse = await Promise.all(
      files.map(async file => {
        if (file) {
          const fileUploadUrl = `https://ohpolly.zendesk.com/api/v2/uploads.json?filename=${file.name}`
          const response = await fetch(fileUploadUrl, {
            method: 'POST',
            headers: {
              'Content-Type': file.type,
            },
            body: file,
          }).then(token => {
            if (token.ok) {
              return token.json()
            }
          })

          const uploadToken = response?.upload?.token
          if (!uploadToken) return

          return uploadToken
        }
      }),
    )

    return tokenResponse
  }

  async fetchRetry (url, options) {
    try {
      return await fetch(url, options)
    } catch (error) {
      if (this.fetchRetries <= this.fetchRetriesMax) {
        const delay = this.fetchRetries * 1000

        await new Promise(resolve => setTimeout(resolve, delay))

        this.fetchRetries++

        return this.fetchRetry(options)
      }

      throw error
    }
  }

  get zendeskTag () {
    const selectEl = this.form.querySelector(
      '[data-contact-form-el="subject-category"] select',
    )
    const selectedOption = selectEl.options[selectEl.selectedIndex]
    const tag = selectedOption.getAttribute('data-zendesk-tag') || 'no_tag_set'

    return tag
  }

  get zendeskSubCategoryTag () {
    const selectEl = this.form.querySelector(
      `[data-contact-form-el="subject-sub-category-${this.form.dataset.subject}"] select`,
    )
    const selectedOption = selectEl.options[selectEl.selectedIndex]
    const tag = selectedOption.getAttribute('data-zendesk-tag') || 'no_tag_set'

    return tag
  }
}

customElements.define('contact-form', ContactForm)
